import { $ } from '../../simpli';
import * as Component from '../../components';
import * as Helper from '../../helpers';
var DefaultConfig = /** @class */ (function () {
    function DefaultConfig() {
    }
    DefaultConfig.components = {
        Multiselect: Component.Multiselect,
        Await: Component.Await,
        Modal: Component.Modal,
        Tip: Component.Tip,
        RenderSchema: Component.RenderSchema,
        AdapOrderby: Component.AdapOrderby,
        AdapPagination: Component.AdapPagination,
        AdapSearchfield: Component.AdapSearchfield,
        InputCheckbox: Component.InputCheckbox,
        InputSelect: Component.InputSelect,
        InputText: Component.InputText,
        InputDate: Component.InputDate,
        RenderAnchor: Component.RenderAnchor,
        RenderImage: Component.RenderImage,
        TransitionExpand: Component.TransitionExpand,
    };
    DefaultConfig.filters = {
        truncate: function (input, length) {
            var value = Helper.toString(input);
            if (value.length > (length || 0)) {
                return value.substring(0, length) + "...";
            }
            return value;
        },
        stripHtml: function (input) {
            var value = Helper.toString(input);
            var doc = new DOMParser().parseFromString(value, 'text/html');
            return doc.body.textContent || '';
        },
        removeDelimiters: function (input) {
            return Helper.toString(input).replace(/[. ,:\-/]+/g, '');
        },
        phone: function (input) {
            return Helper.toString(input)
                .replace(/\D/g, '')
                .replace(new RegExp($.t('filter.phone.regex')), $.t('filter.phone.format'));
        },
        zipcode: function (input) {
            return Helper.toString(input)
                .replace(/\D/g, '')
                .replace(new RegExp($.t('filter.zipcode.regex')), $.t('filter.zipcode.format'));
        },
        rg: function (input) {
            return Helper.toString(input)
                .replace(/\D/g, '')
                .replace(/(\d{2})(\d{3})(\d{3})(\d{1})$/, '$1.$2.$3-$4');
        },
        cpf: function (input) {
            return Helper.toString(input)
                .replace(/\D/g, '')
                .replace(/(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4');
        },
        cnpj: function (input) {
            return Helper.toString(input)
                .replace(/\D/g, '')
                .replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
        },
        cpfOrCnpj: function (input) {
            var value = Helper.toString(input).replace(/\D/g, '');
            if (value.length === 11) {
                return value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4');
            }
            if (value.length === 14) {
                return value.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
            }
            return value;
        },
        pad: function (input, length) {
            if (length === void 0) { length = 2; }
            var value = Helper.toString(input);
            while (value.length < length)
                value = "0" + value;
            return value;
        },
    };
    return DefaultConfig;
}());
export { DefaultConfig };
//# sourceMappingURL=DefaultConfig.js.map